import React, { createContext, useContext, useState } from 'react';
import { LOCALES } from '../constants/locales';

const DEFAULT_COUNTRY = 'PL';
const DEFAULT_CURRENCY = 'PLN';

const CountryContext = createContext({
    country: DEFAULT_COUNTRY,
    currency: DEFAULT_CURRENCY,
    setCountry: () => {}
});

export function CountryProvider({ children }) {
    const [country, setCountryState] = useState(() => localStorage.getItem('country') || DEFAULT_COUNTRY);
    const [currency, setCurrency] = useState(() => localStorage.getItem('currency') || DEFAULT_CURRENCY);

    function setCountry(nextCountry) {
        const locale = LOCALES.find(l => l.country === nextCountry);
        const nextCurrency = locale ? locale.currency : DEFAULT_CURRENCY;
        setCountryState(nextCountry);
        setCurrency(nextCurrency);
        localStorage.setItem('country', nextCountry);
        localStorage.setItem('currency', nextCurrency);
    }

    return (
        <CountryContext.Provider value={{ country, currency, setCountry }}>
            {children}
        </CountryContext.Provider>
    );
}

export function useCountry() {
    return useContext(CountryContext);
}
